import React from 'react';

export default function BlockPrice( {block, className, settingsFunnel} ) {
  // Default values for preview/demo

  let backgroundColor = '#D1F5D3';
  let priceBoxColor = '#E6F9EA';
  let textColor = '#21804C';
  let borderColor = '#B6EAC2';

 
   
    if (block.bgColor === 'green') {
      backgroundColor = '#D1F5D3';    // light mint green background
      priceBoxColor = '#E6F9EA';      // very light green for price box
      textColor = '#21804C';          // deep green for text
      borderColor = '#B6EAC2';        // soft green border
    } else if (block.bgColor === 'blue') {
      backgroundColor = '#E3F2FD';
      priceBoxColor = '#F0F7FF';
      textColor = '#1976D2';
      borderColor = '#BBDEFB';
    } else if (block.bgColor === 'yellow') {
      backgroundColor = '#FFF9DB';
      priceBoxColor = '#FFFBEA';
      textColor = '#A67C1A';
      borderColor = '#FFF6C2';
    } else if (block.bgColor === 'red') {
      backgroundColor = '#FFE5E5';
      priceBoxColor = '#FFF0F0';
      textColor = '#C62828';
      borderColor = '#FFCDD2';
    } else if (block.bgColor === 'theme') {
      backgroundColor = settingsFunnel.primaryColor;
      priceBoxColor = settingsFunnel.secondaryColor;
      textColor = settingsFunnel.textColor;
      borderColor = settingsFunnel.borderColor;
    }
   
  const {
 
    descriptionPrice = 'Produto Mágico <br /> 50% de desconto <br /> <strong>R$97,90</strong>',
    textUp = 'Apenas',
    price = 'R$ 49,90', 
    textDown = 'ou 6x de R$9,36',
   
  } = block;    

  return (
    <div
      className={`rounded-xl p-2 w-full flex items-stretch gap-3  ${className}`}
      style={{
        background: backgroundColor,
        color: textColor,
        border: '1.5px solid #FFF6C2',
        fontFamily: 'inherit',
        fontWeight: 400,
      }}
    >
      <div className="flex flex-col flex-1 justify-center">
       
        <div className="text-base" style={{ color: textColor, marginTop: 2 }}>
          <div dangerouslySetInnerHTML={{ __html: descriptionPrice }} />    
        </div>
     
      </div>
      <div
        className="flex flex-col justify-center items-end px-4 py-2 rounded-lg"
        style={{
          background: priceBoxColor,
          minWidth: 120,
          alignSelf: 'center',
        }}
      >
        <div
          className="text-xs"
          style={{
            color: '#bfa76a',
            fontWeight: 400,
            marginBottom: 2,
          }}
        >
          {textUp}
        </div>
        <div className="flex items-end gap-1">
      
          <span
            className="text-2xl font-bold"
            style={{
              color: textColor,
              lineHeight: 1,
            }}
          >
            {price}
          </span>
        </div>
        <div
          className="text-xs"
          style={{
            color: '#bfa76a',
            fontWeight: 400,
            marginTop: 2,
          }}
        >
          {textDown}
        </div>
      </div>
    </div>
  );
}